// extracted by mini-css-extract-plugin
module.exports = {"root":"TranslationEditor_root__qeCPh","label":"TranslationEditor_label__1tj6P","editor":"TranslationEditor_editor__3cD1X"};